export default {
      id: "units__moving_bg-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#units__moving_bg",
      toString: function () {
        return this.url;
      }
    }